import Vue from 'vue'
import App from './App'
import router from './router'
import common from './assets/js/common'
import './assets/css/reset.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import socketApi from './util/websocket'
// import VConsole from 'vconsole'
import store from './store'

// 引入rem适配
import 'amfe-flexible'

Vue.config.productionTip = false
Vue.prototype.$common = common
Vue.prototype.$socketApi = socketApi
Vue.prototype.$originApi = window.location.origin + '/app-api'
Vue.use(Vant)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})

// 引入控制台
// const vvConsole = new VConsole()
// Vue.use(vvConsole)



// WEBPACK FOOTER //
// ./src/main.js